import { useState } from 'react';
import { useAddArudReport, useRefreshReports } from '@app/sdk';

const reasons: any[] = [
  { code: '0', name: 'Refer to payer' },
  { code: '1', name: 'Instruction cancelled' },
  { code: '2', name: 'Payer deceased' },
  { code: '3', name: 'Account transferred' },
  { code: '4', name: 'Advance notice disputed' },
  { code: '5', name: 'No Account' },
  { code: '6', name: 'No Instruction' },
  { code: '7', name: 'Amount Differs' },
  { code: '8', name: 'Amount not due' },
  { code: '9', name: 'Presentation overdue' },
  { code: 'A', name: 'Originator Differs' },
  { code: 'B', name: 'Account Closed' },
];

export type LastPaymentDetails = {
  date: string;
  amount: number;
};

export function Arudd(props: {
  accountNumber: string;
  customerName: string;
  sortCode: string;
  bankAccountNumber: string;
  lastPaymentDetails: LastPaymentDetails;
  serviceUserNumber: string;
}) {
  const [reasonCode, setReasonCode] = useState(undefined as string);
  const [amount, setAmount] = useState(props.lastPaymentDetails.amount);
  const [originalProcessingDate, setOriginalProcessingDate] = useState(props.lastPaymentDetails.date);
  const refreshReports = useRefreshReports();
  const { mutateAsync: addAruddReport, isPending: submitting } = useAddArudReport();
  const handleSubmit = async (e) => {
    e.preventDefault();

    const reasonDescription = reasons.find((element) => element.code === reasonCode).name;

    await addAruddReport({
      reasonCode: reasonCode,
      accountNumber: props.accountNumber,
      customerName: props.customerName,
      sortCode: props.sortCode,
      bankAccountNumber: props.bankAccountNumber,
      reasonDescription: reasonDescription,
      amount: +amount,
      originalProcessingDate: new Date(originalProcessingDate),
      serviceUserNumber: props.serviceUserNumber
    });
    setTimeout(() => {
      refreshReports();
    }, 100);
  };

  return (
    <>
      <section>
        <form className="ui card" onSubmit={(e) => handleSubmit(e)}>
          <div className="content">
            <div className="ui form">
              <div className="field">
                <label>Reason</label>
                <select onChange={(e) => setReasonCode(e.target.value)} value={reasonCode}>
                  <option>--Select a reason--</option>
                  {reasons.map((r) => (
                    <option key={r.code} value={r.code}>
                      {r.name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="field">
                <label>Amount</label>
                <input
                  type="number"
                  step=".01"
                  value={amount || 0}
                  onChange={(e) => setAmount(parseFloat(e.target.value))}
                  disabled={submitting}
                />
              </div>
              <div className="field">
                <label>Original Processing Date</label>
                <input
                  type="date"
                  value={originalProcessingDate}
                  onChange={(e) => setOriginalProcessingDate(e.target.value)}
                  disabled={submitting}
                />
              </div>
            </div>
          </div>
          <button className={`ui button ${submitting && 'loading'}`} type="submit" disabled={!reasonCode}>
            <span>Add</span>
          </button>
        </form>
      </section>
    </>
  );
}
